import React, { useState, useEffect } from "react";
import PropTypes, { bool } from "prop-types";
import { AvField } from "availity-reactstrap-validation";
import {
  FIELD_STATUS,
  getInitialSelectParams,
  getCurrentDay,
} from "../../helpers/utils";
import DateRange from "./common/DateRange/DateRange";
import DateCalendar from "./common/DateCalendar/DateCalendar";
import StaticDateMonth from "./common/StaticDateMonth/StaticDateMonth";
import { isEqual } from "lodash";
import styled from "styled-components";

const CustomMultipleDateRange = props => {
  const [state, setState] = useState([
    {
      startDate: new Date(getCurrentDay()),
      endDate: new Date(getCurrentDay()),
      key: "selection",
    },
  ]);
  const [open, setOpen] = useState(!true);
  const [style, setStyle] = useState();
  const [calendarDate, setCalendarDate] = React.useState();
  const [value, setValue] = useState("");
  const [dateRangeType, setDateRangeType] = React.useState("start_date");
  const [text, setText] = React.useState("");

  let className = props.className || "";
  let datePicker = {
    ...getInitialSelectParams(),
    value: props.defaultValue || "",
  };
  const defMonth = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if (datePicker.status === FIELD_STATUS.ERROR) {
    className = "select2-custom-error " + className;
  }

  useEffect(() => {
    if (props.datePickerType === 'calendar' && props.defaultValue) {
      onChangeCalendarDate(new Date(props.defaultValue))
      // setCalendarDate(new Date(props.defaultValue))
    }
  }, [props.defaultValue, props.datePickerType])
  // console.log(props.clearedRange)
  useEffect(() => {
    // console.log('hello')
    if (props.clearedRange) {
      onClearDateRange();
      // console.log('hello')
      props.onChangeClearDate && props.onChangeClearDate(true);
    }
  }, [props.clearedRange])

  useEffect(() => {
    document.addEventListener("mousedown", clickOutside, true);
    window.addEventListener("resize", resizeListener, true);
    setStyle({
      ...style,
      width: window.innerWidth,
    });

    return () => {
      document.removeEventListener("mousedown", clickOutside, true);
      window.removeEventListener("resize", resizeListener, true);
    };
  }, []);

  useEffect(() => {
    let currentDay = new Date(getCurrentDay());
    let elem = document.getElementById(`drop-down-calendar-${props.name_id || props.name}`);

    elem !== null &&
      setStyle({
        ...style,
        left: elem.getBoundingClientRect().left,
        right: elem.getBoundingClientRect().right,
        bottom: elem.getBoundingClientRect().bottom,
      });

    if (JSON.stringify(props.value) !== JSON.stringify({})) {
      if (Object.keys(props.value).length !== 0 && props.value !== undefined) {
        let dataSet = [
          {
            startDate:
              props.value.start_date !== undefined
                ? new Date(props.value.start_date)
                : currentDay,
            endDate:
              props.value.end_date !== undefined
                ? new Date(props.value.end_date)
                : currentDay,
            key: "selection",
          },
        ];
        setState(dataSet);
        setValue(prev => {
          if (!isEqual(prev, props.value)) {
            switch (props.datePickerType) {
              case "round":
                setText(
                  `${props.value.start_date || currentDay} to ${props.value.end_date || currentDay
                  }`
                );
                setDateRangeType("start_date");
                return {
                  start_date: props.value.start_date || currentDay,
                  end_date: props.value.end_date || currentDay,
                };
              case "calendar":
                return `${props.value.start_date || currentDay}`;
              case "calendar-with-static":
                let date = new Date(props.value || "");
                setCalendarDate(
                  new Date(props.value) ||
                  new Date(date.getFullYear(), date.getMonth(), 1)
                );
                props.monthTextFormat &&
                  setText(
                    `${defMonth[date.getMonth()]}, ${date.getFullYear()}`
                  );
                break;
            }
          }
        });
      }
    }

    if (open) {
      resizeListener();
      setDateRangeType("start_date");
    }

    if (!open && props.defaultText !== null) {
      setText(
        props.defaultText.end_date == null
          ? `${props.defaultText.start_date || getCurrentDay()} to present`
          : `${props.defaultText.start_date || getCurrentDay()} to ${props.defaultText.end_date || getCurrentDay()
          }`
      );
    }
  }, [props.value, open]);

  const resizeListener = () => {
    let elem = document.getElementById(`drop-down-calendar-${props.name_id || props.name}`);
    let st = {};
    if (elem !== null) {
      st.left = elem.getBoundingClientRect().left;
      st.right = elem.getBoundingClientRect().right;
      st.bottom = elem.getBoundingClientRect().bottom;
    }
    setStyle({
      ...style,
      ...st,
      width: window.innerWidth,
    });
  };

  const clickOutside = e => {
    const path = e.path || (e.composedPath && e.composedPath());
    const staticRanges = document.getElementsByClassName(`rdrStaticRangeLabel`);
    const datePickerBlock = document.getElementById(
      `custom-date-picker-${props.name_id || props.name}`
    );

    if (!path.includes(datePickerBlock)) {
      const btn = document.querySelector(`#custom-date-picker-${props.name_id || props.name}`);
      if (!path.includes(btn)) setOpen(false);
    }

    for (let value of Object.values(staticRanges)) {
      path[0] === value && setDateRangeType("static");
    }
  };

  const onChangeDateRangeWithPresent = item => {
    const data = [item.selection];
    let selectedDate = {
      start_date: new Date(item.selection.startDate.setHours(12))
        .toJSON()
        .split("T")[0],
      end_date: new Date(item.selection.endDate.setHours(12))
        .toJSON()
        .split("T")[0],
    };

    if (dateRangeType == "start_date") {
      props.onChange({
        start_date: selectedDate.start_date,
        end_date: null,
      });
      setDateRangeType("end_date");
      setState(data);
      setValue({
        start_date: selectedDate.start_date,
        end_date: selectedDate.start_date,
      });
      setText(`${selectedDate.start_date} to present`);

    } else if (dateRangeType == "end_date") {
      setDateRangeType("start_date");
      setState(data);
      setValue({
        start_date: selectedDate.start_date,
        end_date: selectedDate.end_date,
      });
      setText(`${selectedDate.start_date} to ${selectedDate.end_date}`);
      props.onChange({
        start_date: selectedDate.start_date,
        end_date: selectedDate.end_date,
      });
    } else {
      props.onChange({
        start_date: selectedDate.start_date,
        end_date: selectedDate.end_date,
      });
      setState(data);
      setValue({
        start_date: selectedDate.start_date,
        end_date: selectedDate.end_date,
      });
      setText(`${selectedDate.start_date} to ${selectedDate.end_date}`);
      setDateRangeType("start_date");
    }
  };

  const onChangeDateRange = item => {
    const data = [item.selection];
    let selectedDate = {
      start_date: new Date(item.selection.startDate.setHours(12))
        .toJSON()
        .split("T")[0],
      end_date: new Date(item.selection.endDate.setHours(12))
        .toJSON()
        .split("T")[0],
    };

    if (dateRangeType == "start_date") {
      setDateRangeType("end_date");
      setState(data);
      setValue({
        start_date: selectedDate.start_date,
      });
    } else if (dateRangeType == "end_date") {
      setDateRangeType("start_date");
      setState(data);
      setValue({
        start_date: selectedDate.start_date,
        end_date: selectedDate.end_date,
      });
      setText(`${selectedDate.start_date} to ${selectedDate.end_date}`);
      props.onChange(selectedDate);
    } else {
      setDateRangeType("start_date");
      setState(data);
      setValue({
        start_date: selectedDate.start_date,
        end_date: selectedDate.end_date,
      });
      setText(`${selectedDate.start_date} to ${selectedDate.end_date}`);
      props.onChange(selectedDate);
    }
  };

  const onChangeCalendarDate = item => {
    console.log('?')
    setCalendarDate(item);
    let selected = new Date(item.setHours(12)).toJSON().split("T")[0];
    setValue(selected);
    setText(selected);
    props.onChange &&
      props.onChange({
        start_date: new Date(item.setHours(12)).toJSON().split("T")[0],
      });
  };

  const onChangeStaticCalendar = item => {
    let selectedDate = new Date(item);
    let selected = new Date(item.setHours(12)).toJSON().split("T")[0];
    setCalendarDate(item);
    setValue(selected);

    if (props.monthTextFormat) {
      setText(
        `${defMonth[selectedDate.getMonth()]}, ${selectedDate.getFullYear()}`
      );
    } else {
      setText(selected);
    }
    props.onChange({
      value: selected,
    });
  };

  const getDatePicker = () => {
    switch (props.datePickerType) {
      case "round":
        return (
          <DateRange style={style} maxDate={props.maxDate} onChange={onChangeDateRange} state={state} customStaticRanges={props.customStaticRanges} />
        );
      case "round-with-present":
        return (
          <DateRange
            style={style}
            onChange={onChangeDateRangeWithPresent}
            state={state}
          />
        );
      case "calendar":
        return (
          <DateCalendar
            style={style}
            date={calendarDate}
            state={state}
            maxDate={props.maxDate}
            onChange={onChangeCalendarDate}
          />
        );
      case "calendar-with-static":
        return (
          <StaticDateMonth
            name={props.name}
            toggle={setOpen}
            style={style}
            customStyle={props.customStyle}
            date={calendarDate}
            state={state}
            onChange={onChangeStaticCalendar}
          />
        );
    }
  };

  const handleClearAll = () => {
    setState([
      {
        startDate: new Date(getCurrentDay()),
        endDate: new Date(getCurrentDay()),
        key: "selection",
      },
    ]);
    setValue("");
    setText("");
  };

  const onClearDateRange = () => {
    switch (props.datePickerType) {
      case "round":
        handleClearAll();
        setDateRangeType("start_date");
        return props.onChange && props.onChange(null);
      // case "round-with-present":
      //   return (
      //     <DateRange
      //       style={style}
      //       onChange={onChangeDateRangeWithPresent}
      //       state={state}
      //     />
      //   );
      case "calendar":
        handleClearAll();
        setCalendarDate(null);
        return props.onChange && props.onChange(null);
      case "calendar-with-static":
        handleClearAll();
        return props.onChange && props.onChange(null);
    }
  };

  return (
    <div
      id={`custom-date-picker-${props.name_id || props.name}`}
      className="custom-date-picker-style"
      style={{ height: 38 }}
    >
      <AvField
        type="text"
        className="form-control"
        placeholder={props.placeholder || "Select date..."}
        name={props.name || "custom-date-picker"}
        value={text || ""}
        style={{
          minWidth: 190,
          cursor: "pointer",
          height: 38,
          fontSize: 13,
          paddingRight: 0,
        }}
        onClick={() => setOpen(!open)}
        validate={{
          required: {
            value: props.required,
            errorMessage: props.errorText,
          },
        }}
        readOnly
      />
      {props.clearDate && (
        <ClearStyle onClick={() => onClearDateRange()}>
          <span>
            <i className="mdi mdi-filter-off text-white" />
          </span>
        </ClearStyle>
      )}
      {open && (
        <div id={`drop-down-calendar-${props.name_id || props.name}`}>{getDatePicker()}</div>
      )}
    </div>
  );
};

const ClearStyle = styled.div`
  border-bottom-right-radius: 0.25rem;
  width: 5px;
  border-top-right-radius: 0.25rem;
  height: 37px;
  background: #34c38f;
  position: absolute;
  top: 26px;
  right: 0px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  vertical-align: middle;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  span {
    opacity: 0;
    width: 0;
    display: none;
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    width: 23px;
    color: #2a9c72;
    span {
      display: block;
      opacity: 1;
      width: auto;
    }
  }
`;

CustomMultipleDateRange.defaultProps = {
  value: {},
  required: false,
  datePickerType: "round",
  placeholder: "Select date range...",
  errorText: "Can't be empty",
  defaultText: null,
  customStyle: {},
  monthTextFormat: false,
  customStaticRanges: false,
};

CustomMultipleDateRange.propTypes = {
  value: PropTypes.any,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  name_id: PropTypes.string,
  datePickerType: PropTypes.string.isRequired,
  staticDay: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  required: PropTypes.bool,
  errorText: PropTypes.string,
  defaultText: PropTypes.any,
  customStyle: PropTypes.any,
  monthTextFormat: PropTypes.bool,
  clearDate: PropTypes.bool,
  customStaticRanges: bool,
  clearedRange: PropTypes.bool,
  onChangeClearDate: PropTypes.func,
  maxDate: PropTypes.string,
  maxDate: PropTypes.string
};

export default CustomMultipleDateRange;
